// Display helpers for business dates ('YYYY-MM-DD' strings).
//
// Never build a Date from a bare 'YYYY-MM-DD' string for display: JavaScript reads
// it as UTC midnight and formats it in the device's zone, so a phone set to a
// zone behind UTC shows the PREVIOUS day. These helpers only split the string.

const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
const SHORT = MONTHS.map((m) => m.slice(0, 3))

function parts(iso: string): { y: number; m: number; d: number } | null {
  const match = /^(\d{4})-(\d{2})(?:-(\d{2}))?/.exec(iso)
  if (!match) return null
  const m = Number(match[2])
  if (m < 1 || m > 12) return null
  return { y: Number(match[1]), m, d: match[3] ? Number(match[3]) : 1 }
}

/** '2026-09-30' -> '30 Sep 2026' */
export function formatDay(iso: string): string {
  const p = parts(iso)
  return p ? `${p.d} ${SHORT[p.m - 1]} ${p.y}` : iso
}

/** '2026-09-30' or '2026-09' -> 'September 2026' */
export function formatMonth(iso: string): string {
  const p = parts(iso)
  return p ? `${MONTHS[p.m - 1]} ${p.y}` : iso
}

/** '2026-09' -> the month before/after, as 'YYYY-MM'. */
export function shiftMonth(ym: string, delta: number): string {
  const p = parts(ym)
  if (!p) return ym
  const index = p.y * 12 + (p.m - 1) + delta
  const y = Math.floor(index / 12)
  const m = (index % 12) + 1
  return `${y}-${String(m).padStart(2, '0')}`
}

/** 1 -> '1st', 2 -> '2nd', 11 -> '11th', 22 -> '22nd' */
export function ordinal(n: number): string {
  const v = n % 100
  if (v >= 11 && v <= 13) return `${n}th`
  return `${n}${({ 1: 'st', 2: 'nd', 3: 'rd' } as Record<number, string>)[n % 10] ?? 'th'}`
}
